import GoogleThirdBtn from "../ui/GoogleThirdBtnCustom";
import Image from "next/image";
import AutoFitText from "../ui/AutoFitText";
import { useTranslation } from "next-i18next";
import { sendSlsEvent } from "@/hooks/useAnalytics";
import { useEffect } from "react";
import { MailIcon } from "@/components/icons";
import { useElapsedTime } from "@/utils/useElapsedTime";
import { useRouter } from "next/router";
const EmailRegistred = ({
  userInputEmail,
  goVerifyCode,
  onVerifyCodeType,
  onClose,
  origin,
}: {
  onClose: () => void;
  goLogin: () => void;
  goVerifyCode: () => void;
  userInputEmail: string;
  onVerifyCodeType: (type: string) => void;
  origin: "login" | "registry";
}) => {
  const { t } = useTranslation();
  const getElapsed = useElapsedTime();
  const router = useRouter();
  const code = router?.query?.code as string;

  const pageId =
    origin == "login"
      ? "maillogin_choosepage_web"
      : "mailsignup_choosepage_web"; // 跳转来源
  const handleLeft = () => {
    console.log("handleLeft---email-google-registred-and-no-password----");
    sendSlsEvent({
      UM_Key_EventName: "UM_Event_PageLeave",
      UM_Key_PageName: pageId,
      UM_Key_UserType: "Guest",
      UM_Key_SourcePage: router.route,
      UM_Key_Duration: getElapsed(),
    });
  };
  useEffect(() => {
    sendSlsEvent({
      UM_Key_EventName: "UM_Event_PageView",
      UM_Key_PageName: pageId,
      UM_Key_UserType: "Guest",
      UM_Key_SourcePage: router.route,
    });
    return () => {
      handleLeft();
    };
  }, []);

  return (
    <div className="flex flex-col w-[calc(100vw-40px)]">
      <div className="flex flex-row text-[14px] font-[700] font-['Mulish'] text-[#999] mt-[25px]">
        <span className="text-[#333]">{userInputEmail}</span>
        <span className="text-[14px] font-[400] font-['Mulish'] text-[#999]  mb-[20px]">
          {t("login.logInDirectly")}
        </span>
      </div>
      <GoogleThirdBtn
        pageId={pageId}
        buttonName="choosegoogle"
        onSetThirdPsw={() => {}}
        onFinish={() => {
          onClose();
        }}
      />
      <div
        onClick={() => {
          onVerifyCodeType("1"); // 忘记密码

          sendSlsEvent({
            UM_Key_EventName: "UM_Event_ModularClick",
            UM_Key_ButtonName: "choosemail_setpassword",
            UM_Key_PageName: pageId,
            UM_Key_UserType: "Guest",
            UM_Key_SourcePage: router.route,
            UM_Key_ResourceID: code,
          });
          goVerifyCode();
        }}
        style={{
          width: "100%",
          padding: "0 20px",
          fontFamily: "Mulish",
          fontWeight: "700",
          fontSize: "16px",
          color: "#333",
          backgroundColor: "#f2f2f4",
          borderRadius: "8px",
          border: "1px solid #f2f2f2",
          height: "56px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "16px",
        }}
      >
        <MailIcon></MailIcon>
        <AutoFitText
          text={t("login.continueWithEmailSetPsw")}
          style={{ marginLeft: "8px" }}
        />
      </div>
    </div>
  );
};

export default EmailRegistred;
